import React from "react";
import ProductsMainSectionDetails from "../ProductsMainSectionDetails/ProductsMainSectionDetails";

export function ProductsLayoutDetails() {

  return <ProductsMainSectionDetails />;
}
